// extracted by mini-css-extract-plugin
module.exports = {"camp-K":"K_camp-K__0APZY"};